jQuery(document).ready(function($){
    function inview_animate(elem) {
        new Waypoint.Inview({
            element: elem,
            enter: function (direction) {
                $(this.element).addClass($(elem).data('animate') + ' animated');
            }
        })
    }

    $('[data-animate]').each(function () {
        inview_animate(this);
    });

    $('.slider-photo').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var slide = slick.$slides.eq(nextSlide);
        slide.find('.slide__title, .slide__description, .slide__buttons').hide().removeClass('pulse animated');
    });

    $('.slider-photo').on('afterChange', function (event, slick, currentSlide) {
        var slide = slick.$slides.eq(currentSlide);
        slide.find('.slide__title, .slide__description, .slide__buttons').addClass('pulse animated ').show();
    });

});
